import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getAllStores } from "../../../../../../api/userRegestration/CollectionForm";

export default function Viewallregestration() {
  const [categories, setCategories] = useState([]);
  const accessToken = localStorage.getItem("token");
  const navigate = useNavigate();

  // Modify handlenavigate to accept the store ID as an argument
  const handlenavigate = (storeId) => {
    navigate(`/findproduct/ProductPage/${storeId}`);
  };

  useEffect(() => {
    getAllStores(accessToken)
      .then((result) => {
        setCategories(result);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [accessToken]);

  const handlelistener = () => {
    navigate(`/`);
  };

  return (
    <>
      <div className="bg-layout drop-shadow-md lg:w-[152vh] mb-12 lg:ml-[17rem] relative top-[1rem] swing-in-top-fwd">
        <h1 className="font-all font-semibold text-center text-[24px] mt-4 mb-12">
          My Stores List
        </h1>

        <div className="flex flex-col">
          <div className="overflow-x-auto sm:mx-0.5 lg:mx-0.5">
            <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                <table className="min-w-full">
                  <tbody>
                    {categories.map((category, index) => (
                      <tr
                        key={category._id}
                        className="bg-white border-b transition duration-300 ease-in-out hover:bg-gray-100"
                      >
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {index + 1}-
                        </td>
                        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
                          <img
                            className="h-[55px] w-[55px] rounded-md bg-yellow-100"
                            src={category.banner}
                            alt=""
                          />
                        </td>
                        <td className="text-sm  font-all font-semibold px-6 py-4 whitespace-nowrap">
                          {category.name}
                        </td>
                        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
                          <button
                            onClick={() => handlenavigate(category._id)}
                            className="bg-[#F8F8F8] h-[40px] w-[123px] shadow-lg rounded-full transform hover:scale-105 duration-500 ease-in-out hover:bg-[#CB2229] hover:text-white flex flex-row items-center justify-center gap-2"
                          >
                            View full Store
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="--content--inquiries">
          <div className="button--action--reverse flex justify-center ">
            <button
              onClick={handlelistener}
              className=" my-[2rem] bg-[#F8F8F8] shadow-lg p-[3px] w-[12rem] rounded-full transform hover:scale-105 duration-500 ease-in-out hover:bg-[#CB2229]  border-[1px] border-[#CB2229] hover:text-white flex flex-row items-center justify-center gap-2"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
